import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-alladdlist',
  templateUrl: './alladdlist.component.html',
  styleUrls: ['./alladdlist.component.scss']
})
// export class AlladdlistComponent {

// }

export class AlladdlistComponent implements OnInit {
  allAddList: any;

  constructor(private dialogRef: MatDialogRef<AlladdlistComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,private fb: FormBuilder,private datePipe:DatePipe
  )
   { }

   district:any
   taluka:any;
   modetype:any
   start_date:any
   end_date:any
   prantname:any
   country:any
   state:any
   duration:any
   repDataList: any[] = [];
   delivery_mode: any
   prant_name: any
   sub_type: any
   rep_name: any
   pincode:any
   officer: any
   disrepname: any

  ngOnInit(): void {

    // this.district= this.data['districtName']
    // this.taluka= this.data['talukaName']
    // this.modetype= this.data['modeType']
    // this.start_date=  this.data['date']
    // this.end_date=  this.data['endDate']
    // this.prantname= this.data['prantname']
    // this.country=this.data['country']
    // this.state=this.data['state']
    // this.duration=this.data['duration']

    this.start_date=  this.data['date']
    this.end_date=  this.data['endDate']
    this.country= this.data['country']
    this.state=this.data['state']
    this.district= this.data['district_name']
    this.taluka= this.data['taluka_name']
    this.delivery_mode= this.data['delivery_mode']
    this.prant_name= this.data['prant_name']
    this.sub_type = this.data['sub_type']
    this.rep_name= this.data['rep_name']
    this.pincode= this.data['pincode']
    this.officer = this.data['officer']
    this.disrepname = this.data['disrepname']

    // const req:any = {
    
    //   "delivery_mode":this.modetype,
    //   "district":this.district,
    //   "taluka":this.taluka,
    //   "start_date": this.start_date,
    //   "end_date": this.end_date,
    //   "prant_name": this.prantname,
    //   "country": this.country,
    //   "state": this.state,
    //   "sub_type":this.duration,
    
    // }

    const req:any = {
    
      "delivery_mode":this.delivery_mode,
      "district":this.district,
      "taluka":this.taluka,
      "start_date": this.start_date,
      "end_date": this.end_date,
      "prant_name": this.prant_name,
      "country": this.country,
      "state": this.state,
      "sub_type":this.sub_type,
      "rep_name":this.rep_name,
      "pincode":this.pincode,
      "officer":this.officer,
      "disrepname":this.disrepname,
    
    }

    console.log(req, "new all address")

    this.service.getgetAllAddList(req).subscribe((data:any) => {
      console.log("All Address List Data =",data);
     this.allAddList = (data as any);
    //  if (Array.isArray(data) && data[0]?.rep_data?.length) {
    //   this.repDataList = data[0].rep_data;
    // } else {
    //   this.repDataList = [];
    // }
    });
    console.log("req 2 for add", req)
  }

    exportExcel(fileName): void {
        /* table id is passed over here */
        let element = document.getElementById('print-section');
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
        /* save to file */
        XLSX.writeFile(wb, fileName + '.xlsx');
      }


    show=false 
    //Old Correct Code 
  //   printPage() {
  //     this.show = true;
  //     const printContent = document.getElementById('print-section')?.outerHTML;
  //     if (!printContent) {
  //       console.error("Print section not found!");
  //       return;
  //     }
    
  //     const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
    
  //     if (printWindow) {
  //       printWindow.document.open();
  //       printWindow.document.write(`
  //         <html>
  //           <head>
  //             <title>Print Report</title>
  //             <style>
  //               @media print {
  //                  @page {
  //   size: A3 landscape;
  //   margin: 5mm;
  // }
  // html, body {
  //   margin: 0;
  //   padding: 0;
  //   font-family: Arial, sans-serif;
  //   font-size: 15px;
  //   line-height: 1.2;
  //   overflow: hidden;
  // }
  // table {
  //   width: 100%;
  //   border-collapse: collapse;
  //   table-layout: fixed;
  // }
  // tr {
  //   page-break-inside: avoid; /* Prevent row splitting across pages */
  //   break-inside: avoid;
  // }
  // th, td {
  //   padding: 1px;
  //   border: 1px solid black;
  //   text-align: center;
  //   font-size: 14px;
  //   line-height: 1.2;
  //   box-sizing: border-box;
  // }
  // .noPrint {
  //   display: none;
  // }
  //               }
  //             </style>
  //           </head>
  //           <body>
  //             <div id="print-section">
  //               ${printContent}
  //             </div>
  //             <script>
  //               window.onload = function() {
  //                 window.print();
  //                 setTimeout(() => { window.close(); }, 500);
  //               };
  //             </script>
  //           </body>
  //         </html>
  //       `);
  //       printWindow.document.close();
  //     } else {
  //       console.error("Failed to open print window.");
  //     }
  //   }
    
  //Less Address New Code
 printPage() {
    this.show = true;
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
      console.error("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Report</title>
           <style>
@media print {
  @page {
    size: A3 landscape;
    margin: 5mm;
  }

  html, body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    font-size: 15px;
    line-height: normal;
 
  }

  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: auto;
  }

  tr {
    page-break-inside: avoid;
  }

  th {
    padding: 1px;
    border: 1px solid black;
    text-align: center;
    font-size: 14px;
    line-height: normal;
    box-sizing: border-box;
  }

  td {
    padding: 1px;
    border: 1px solid black;
    text-align: left;
    font-size: 14px;
    line-height: normal;
    box-sizing: border-box;
  }

  .noPrint {
    display: none;
  }
}
</style>

          </head>
          <body>
            <div id="print-section">
              ${printContent}
            </div>
            <script>
              window.onload = function() {
                window.print();
                setTimeout(() => { window.close(); }, 500);
              };
            </script>
          </body>
        </html>
      `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }

}
